// EVENTS.COMPONENTS.APPLICATION.REWARDS.EARN.ACHIEVEMENT_CARD.CLAIM_POINTS_MODAL

export const CLAIM_POINTS_MODAL = {
  CLAIM: 'achievement_claim-opened_modal'
};
